import React from 'react';
import Input from '../Input';

const DescriptionInput = ({
  width,
  value,
  validate,
  valid,
  disabled,
  setValue,
  userData,
}) => {
  return (
    <Input
      id={'Descricao'}
      isTextArea
      labelName={'Descrição'}
      placeholder={'Digite aqui a sua dúvida...'}
      size={width}
      disabled={disabled}
      value={value}
      marginTop={0}
      onBlur={validate}
      error={valid === false}
      maxLength={1000}
      handleInputChange={(e) =>
        setValue({ ...userData, Descricao: e.currentTarget.value })
      }
    />
  );
};

export default DescriptionInput;
